/** Keys for `useNewCode` / `useFlag` (app-shell IA rebrand and related toggles). */

/** Beta cohort gate for AP brand/product refresh 2026. */
export const PRODUCT_REFRESH_GLOBAL_FLAG_KEY = 'ap_product_refresh_2026_global'

/** When on with the global cohort flag, product refresh applies without user opt-in. */
export const PRODUCT_REFRESH_GLOBAL_OPT_IN_DISABLED_FLAG_KEY = 'ap_product_refresh_2026_global_opt_in_disabled'

/** Alpha cohort only — frozen; no new enrollments. Beta users enter via `PRODUCT_REFRESH_GLOBAL_FLAG_KEY`. */
// TODO(product-refresh-cleanup): Remove ap_rebrand_app_shell_ia once product refresh is GA
export const APP_SHELL_FLAG_KEY = 'ap_rebrand_app_shell_ia'
// TODO(product-refresh-cleanup): Remove ap_rebrand_ui_theme once product refresh is GA
export const UI_THEME_FLAG_KEY = 'ap_rebrand_ui_theme'
// TODO(product-refresh-cleanup): Remove ap_rebrand_settings_ia once product refresh is GA
export const SETTINGS_IA_FLAG_KEY = 'ap_rebrand_settings_ia'
